// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@conklin/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 32px;
    `,
};

categoriesStyles.container = {
    css: css`
        margin: 30px 0;
    `,
};

categoriesStyles.categoryContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        ${({ gridType }: any) => {
            if (gridType !== "row") {
                return css`
                    flex-direction: column;
                `;
            }
        }}
        ${xScreen("lte", "xs")} {
            justify-content: center;
        }
    `,
};

categoriesStyles.innerCategoryContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: calc((100% / 3) - 15px);
        ${xScreen("lte", "sm")} {
            width: calc((100% / 2) - 5px);
        }
        ${xScreen("lte", "xs")} {
            align-items: center;
            width: 100%;
        }
    `,
};

categoriesStyles.categoryImage = {
    css: css`
        object-fit: cover;
        width: 200px;
        height: 200px;
        img {
            width: 100%;
        }
        ${xScreen("lte", "md")} {
            width: 165px;
            height: 165px;
        }
        ${xScreen("lte", "sm")} {
            width: 150px;
            height: 150px;
        }
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        size: 15,
        weight: fontConfig.weight.bold,
    },
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        display: block;
        margin-top: 11px;
        &&& span {
            color: ${color("text.main")};
        }
    `,
};

categoriesStyles.subCategoryItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        padding-top: 2px;
        padding-bottom: 3px;
    `,
};

categoriesStyles.subCategoryLink = {
    typographyProps: {
        color: "text.main",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    css: css`
        text-align: left;
    `,
};

categoriesStyles.viewMoreLinkItem = {
    width: 12,
    css: css`
        padding-top: 5px;
    `,
};

categoriesStyles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        height: auto;
        width: 100%;
        ${xScreen("lte", "xs")} {
            display: flex;
            justify-content: center;
        }
    `,
};
